"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = require("../../../../../shared/services");
var initialState = function () {
    return {
        formId: '',
        formKey: '',
        currentStep: 1,
        shippingMethod: null,
        billingIsSameAsShipping: services_1.appSessionStorage.getItem('checkout-billing-is-same-as-shipping', true),
        billingAddress: services_1.appSessionStorage.getItem('checkout-billing-address', {}),
        shippingAddress: services_1.appSessionStorage.getItem('checkout-shipping-address', {}),
        extensionAttributes: services_1.appSessionStorage.getItem('checkout-extension-attributes', {}),
    };
};
var state = initialState();
var getters = {
    billingAddress: function (state) { return state.billingIsSameAsShipping ? state.shippingAddress : state.billingAddress; },
    shippingAddress: function (state) { return state.shippingAddress; },
    getAddressData: function (state, getters, rootState, rootGetter) {
        if (rootGetter['CheckoutGlobal/isLoggedIn']) {
            return getters.convertAddressData;
        }
        return [getters.billingAddress, getters.shippingAddress];
    },
    customerAddressInformation: function (state, getters) {
        var _a = getters.convertAddressData, _billingAddress = _a[0], _shippingAddress = _a[1];
        return {
            billingInformation: _billingAddress,
            shippingInformation: _shippingAddress
        };
    },
    convertAddressData: function (state, getters, rootState) {
        var shippingAddress = {
            city: state.shippingAddress['city'] || '',
            company: state.shippingAddress['company'] || '',
            countryId: state.shippingAddress['country_id'] || 'NL',
            customerAddressId: state.shippingAddress['entity_id'] || null,
            email: rootState['CheckoutGlobal']['customerEmail'] || null,
            customerId: rootState['CheckoutGlobal']['customer'].hasOwnProperty('entity_id') ? rootState['CheckoutGlobal']['customer']['entity_id'] : null,
            firstname: state.shippingAddress['firstname'] || '',
            middlename: state.shippingAddress['middlename'] || '',
            lastname: state.shippingAddress['lastname'] || '',
            postcode: state.shippingAddress['postcode'] || '',
            prefix: state.shippingAddress['prefix'] || '',
            region: null,
            regionCode: null,
            saveInAddressBook: state.shippingAddress['newAddress'] ? 1 : null,
            street: 'string' === typeof state.shippingAddress['street'] ? state.shippingAddress['street'].split(/\n/) : state.shippingAddress['street'] || ['', '', ''],
            telephone: state.shippingAddress['telephone'],
        };
        var billingAddress = state.billingIsSameAsShipping ? __assign({}, shippingAddress) : {
            city: state.billingAddress['city'] || '',
            company: state.billingAddress['company'] || '',
            countryId: state.billingAddress['country_id'] || '',
            customerAddressId: state.billingAddress['entity_id'] || null,
            email: rootState['CheckoutGlobal']['customerEmail'] || null,
            customerId: rootState['CheckoutGlobal']['customer'].hasOwnProperty('entity_id') ? rootState['CheckoutGlobal']['customer']['entity_id'] : null,
            firstname: state.billingAddress['firstname'] || '',
            middlename: state.billingAddress['middlename'] || '',
            lastname: state.billingAddress['lastname'] || '',
            postcode: state.billingAddress['postcode'] || '',
            prefix: state.billingAddress['prefix'] || '',
            region: null,
            regionCode: null,
            saveInAddressBook: state.billingAddress['newAddress'] ? 1 : null,
            street: 'string' === typeof state.billingAddress['street'] ? state.billingAddress['street'].split(/\n/) : state.billingAddress['street'] || ['', '', ''],
            telephone: state.billingAddress['telephone'],
        };
        if (state.billingIsSameAsShipping) {
            billingAddress['saveInAddressBook'] = null;
        }
        return [
            billingAddress,
            shippingAddress
        ];
    }
};
var mutations = {
    SET_BILLING_IS_SAME_AS_SHIPPING: function (state, status) {
        services_1.appSessionStorage.setItem('checkout-billing-is-same-as-shipping', status);
        state.billingIsSameAsShipping = status;
    },
    SET_CURRENT_STEP: function (state, step) {
        state.currentStep = step;
    },
    SET_BILLING_ADDRESS: function (state, address) {
        services_1.appSessionStorage.setItem('checkout-billing-address', address);
        state.billingAddress = address;
    },
    SET_SHIPPING_ADDRESS: function (state, address) {
        services_1.appSessionStorage.setItem('checkout-shipping-address', address);
        state.shippingAddress = address;
    },
    ADD_EXTENSION_ATTRIBUTE: function (state, extensionAttribute) {
        state.extensionAttributes = __assign(__assign({}, state.extensionAttributes), extensionAttribute);
        services_1.appSessionStorage.setItem('checkout-extension-attributes', state.extensionAttributes);
    },
    REMOVE_EXTENSION_ATTRIBUTE: function (state, extensionAttribute) {
        if (state.extensionAttributes.hasOwnProperty(extensionAttribute)) {
            delete state.extensionAttributes[extensionAttribute];
        }
        services_1.appSessionStorage.setItem('checkout-extension-attributes', state.extensionAttributes);
    }
};
var actions = {
    /* Init */
    setFormId: function (_a, payload) {
        var commit = _a.commit;
        commit('SET_FORM_ID', payload.formId);
    },
    setFormKey: function (_a, payload) {
        var commit = _a.commit;
        commit('SET_FORM_KEY', payload.formKey);
    },
    gotoStep: function (_a, step) {
        var state = _a.state, commit = _a.commit, getters = _a.getters;
        if (step === state.currentStep) {
            return;
        }
        if (step - state.currentStep > 1) {
            commit('SET_CURRENT_STEP', step - 1);
        }
        else {
            commit('SET_CURRENT_STEP', step);
        }
    },
    /* Step 1 */
    checkCustomerEmail: function (_a, customerEmail) {
        var state = _a.state, commit = _a.commit, rootState = _a.rootState;
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$mageClient.post("/rest/".concat(rootState['CheckoutGlobal']['storeCode'], "/V1/customers/isEmailAvailable"), {
                                customerEmail: customerEmail,
                            })];
                    case 1: return [2 /*return*/, _b.sent()];
                    case 2:
                        e_1 = _b.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    },
    newsletterSubscribe: function (_a, newsletterSubscribe) {
        var state = _a.state, commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                commit('ADD_EXTENSION_ATTRIBUTE', {
                    newsletter_subscribe: newsletterSubscribe,
                });
                return [2 /*return*/];
            });
        });
    },
    setBillingAddress: function (_a, payload) {
        var commit = _a.commit;
        commit('SET_BILLING_ADDRESS', payload.address);
    },
    setShippingAddress: function (_a, payload) {
        var commit = _a.commit;
        commit('SET_SHIPPING_ADDRESS', payload.address);
    },
    toggleBillingIsSameAsShipping: function (_a) {
        var state = _a.state, commit = _a.commit;
        commit('SET_BILLING_IS_SAME_AS_SHIPPING', !state.billingIsSameAsShipping);
    }
};
var CheckoutCheckout = {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};
exports.default = CheckoutCheckout;
